import { createAsyncThunk as createAsyncThunkRTK } from '@reduxjs/toolkit';
import { Dispatch, ExtraArguments, State } from '../client/configureStore';

export const createAsyncThunk = createAsyncThunkRTK.withTypes<{
  state: State;
  dispatch: Dispatch;
  extra: ExtraArguments;
}>();
